import { ApiService } from '~/shared/api'
import type { HttpClient } from '~/shared/api'
import { DadataAddressModel } from '~/models/dadata'
import type { DadataSuggestionAddressInput } from '~/shared/types/dadata'
import { unwrapToModels } from '~/shared/utils/response'

const DEFAULT_HINTS_COUNT = 10

export class DadataAddressService extends ApiService {
  readonly urls: {
    suggestions: string
  }

  constructor(http: HttpClient, dadataBaseUri: string) {
    super(http)
    this.urls = {
      suggestions: `${dadataBaseUri.replace(/\/+$/, '')}/suggest/address`,
    }
  }

  suggestions(params: DadataSuggestionAddressInput): Promise<Array<DadataAddressModel>> {
    return this.http
      .request({
        url: this.urls.suggestions,
        method: 'POST',
        data: { ...params, count: params.count ?? DEFAULT_HINTS_COUNT },
        silent: true,
      })
      .then(res => unwrapToModels(res.data, DadataAddressModel, 'suggestions'))
      .catch(() => [])
  }
}
